import React from 'react';
import { Button } from 'reactstrap';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { modelOf } from '../../../prop-types';
import Icon from '../../common/Icon';
import MarkerBadge from '../../common/MarkerBadge';
import RequestState from '../../../types/RequestState';
import ProposalStore from '../../../store/ProposalStore';

const MobileNavigationProposal = ({
  proposalStore,
  className,
  wrapperClassName,
}) => {
  const hasCountOverflow = () => proposalStore.cart.number_of_products >= 100;

  const getProductCount = () => {
    return hasCountOverflow() ? '99+' : proposalStore.cart.number_of_products;
  };

  const getMarkerStyles = () => {
    return { fontSize: hasCountOverflow() ? '0.7rem' : null };
  };

  return (
    <div className={classNames('MobileNavigationProposal', className)}>
      <div
        className={classNames(
          'MobileNavigationProposal__cart-button-wrapper',
          wrapperClassName
        )}
      >
        <Button
          color="plain"
          className="CommonNavigation__icons"
          onClick={() => proposalStore.proposalModal.toggle(true)}
          disabled={proposalStore.state !== RequestState.LOADED}
        >
          <Icon name="list" />
          {proposalStore.cart && (
            <MarkerBadge
              className="d-xs-inline d-md-none"
              style={getMarkerStyles()}
            >
              {getProductCount()}
            </MarkerBadge>
          )}
        </Button>
      </div>
    </div>
  );
};

MobileNavigationProposal.propTypes = {
  proposalStore: modelOf(ProposalStore).isRequired,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
};

MobileNavigationProposal.defaultProps = {
  className: '',
};

export default inject((stores) => ({
  proposalStore: stores.proposalStore,
}))(observer(MobileNavigationProposal));
